import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { OnlineBillPayIdentifierSettings } from '../../OnlineBillPaySettings/identifierSettings/onlinebillpay-identifier-settings';
import { OnlineBillPaySettings } from '../../OnlineBillPaySettings/onlinebillpay-settings';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';

export const OnlineBillPayGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useAppFlagStore();

  const obpNewFieldsFF = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.ObpNewFields,
    locationIds: locationIds,
    strategy: 'ANY',
  });
  return (
    <section>
      {locationIds.length === 1 ? (
        <>
          <PaymentSettingsCard locationId={locationIds[0]}>
            <OnlineBillPaySettings />
          </PaymentSettingsCard>
          {obpNewFieldsFF && (
            <PaymentSettingsCard locationId={locationIds[0]}>
              <OnlineBillPayIdentifierSettings />
            </PaymentSettingsCard>
          )}
        </>
      ) : (
        <PaymentSettingsGroup>
          <OnlineBillPaySettings />
          <OnlineBillPayIdentifierSettings inMulti />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
